import React, { Component } from "react";

import crossImg from "../../images/xs.svg";

class CarrierMessages extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleDocumentKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }

  handleDocumentKeyDown = (event) => {
    if (event.key === "Escape") {
      this.props.hideCarrierMessages();
    }
  }

  convertDate(date) {
    var messageDate = new Date(date);
    var month = messageDate.toLocaleString("en-US", { month: "short" });
    var day = `0${messageDate.getDate()}`.slice(-2);
    var year = messageDate.getFullYear();
    var time = messageDate
      .toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      .toLowerCase();
      
    return `${month} ${day}, ${year} @ ${time}`;
  }

  render() {
    return (
      <div className="service-transaction-popup">
        <div className="background" onClick={() => this.props.hideCarrierMessages()} />
        <div className="popup" style={{ width: "560px" }}>
          <div className="popup-content">
            <div className="service-transactions-popup-header fixed">
              <div
                className="close-icon"
                onClick={() => this.props.hideCarrierMessages()}
              >
                <img src={crossImg} alt="close" />
              </div>
              <div xxxclassName="title" style={{ fontWeight: "bold" }}>Carrier Messages</div>
              <div className="delimeter" />
              {/* <div className="title">Carrier Messages</div>
              <div className="delimeter" />
              <div className="quote-info">
                <div>
                  <span className="tile">Carrier: </span>
                  <span className="value">{this.props.quote.Carrier}</span>
                </div>
                <div>
                  <span className="tile">Line of Business: </span>
                  <span className="value">
                    {this.props.quote.Lob}
                  </span>
                </div>
                <div>
                  <span className="tile">Quote #</span>
                  <span className="value">{this.props.quote.Id}</span>
                </div>
              </div>
              <div className="delimeter" /> */}
              <ul className="messages" style={{ paddingLeft: "1.5em" }}>
                {this.props.quote.CarrierMessages &&
                  this.props.quote.CarrierMessages.map((item, index) => {
                    var isAttentionMessage = item.Message.startsWith(
                      "Attention: This quote qualifies"
                    );

                    return (
                      <React.Fragment key={index}>
                        {/* {!isAttentionMessage ? (
                          <div className="info">
                            <span className="type">
                              {item.CarrierMessageType} Message
                            </span>
                            <span className="date">
                              {this.convertDate(item.DateTime)}
                            </span>
                          </div>
                        ) : null} */}
                        <li className="message" style={{ marginBottom: "1em" }}>
                          {isAttentionMessage ? (
                            <>
                              <b>Attention:</b>
                              {item.Message.substr("Attention:".length)}
                            </>
                          ) : (
                            item.Message
                          )}
                        </li>
                      </React.Fragment>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CarrierMessages;
